import { render, staticRenderFns } from "./ChartFaturamentoAnual.vue?vue&type=template&id=601b0ec1"
import script from "./ChartFaturamentoAnual.vue?vue&type=script&lang=js"
export * from "./ChartFaturamentoAnual.vue?vue&type=script&lang=js"
import style0 from "./ChartFaturamentoAnual.vue?vue&type=style&index=0&id=601b0ec1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports